module.exports = __webpack_public_path__ + "img/9.29004590.png";